import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import ObjectDrawingUIAction from '../../../actions/ui/ObjectDrawingUIAction';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../../reducers/app';
import { Color } from '../../../types/color';
import SelectableColorIconButton from '../../common/SelectableIconButton/SelectableColorIconButton';

interface ObjectFillColorTabPanelListRowProps {
  selected: number;
  fillColor: Color;
  dispatch: Dispatch<Action>;
}

const titleContainerStyle: React.CSSProperties = {
  width: '105px',
};

const titleStyle: React.CSSProperties = {
  width: '92px',
};

const ObjectFillColorTabPanelListRow: React.SFC<
  ObjectFillColorTabPanelListRowProps
> = React.memo((props) => {
  const { selected, fillColor, dispatch } = props;

  return (
    <SettingTabPanelListRow>
      <SettingTabPanelListRowImageTitle
        imgName="text_shape_color"
        containerStyle={titleContainerStyle}
        imageStyle={titleStyle} />
      <ToolIconRadioButtonSet style={{ width: '400px' }}>
        <SelectableColorIconButton
          title="赤"
          imagePath="images/setting-popup/color/btn_color_red_01"
          active={fillColor === Color.Red}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.Red, dispatch)} />
        <SelectableColorIconButton
          title="青"
          imagePath="images/setting-popup/color/btn_color_blue_01"
          active={fillColor === Color.Blue}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.Blue, dispatch)} />
        <SelectableColorIconButton
          title="黄色"
          imagePath="images/setting-popup/color/btn_color_yellow_01"
          active={fillColor === Color.Yellow}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.Yellow, dispatch)} />
        <SelectableColorIconButton
          title="緑"
          imagePath="images/setting-popup/color/btn_color_green_01"
          active={fillColor === Color.Green}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.Green, dispatch)} />
        <SelectableColorIconButton
          title="黒"
          imagePath="images/setting-popup/color/btn_color_black_01"
          active={fillColor === Color.Black}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.Black, dispatch)} />
        <SelectableColorIconButton
          title="白"
          imagePath="images/setting-popup/color/btn_color_white_01"
          active={fillColor === Color.White}
          onClick={() => ObjectDrawingUIAction.setColor(selected, Color.White, dispatch)} />
        <SelectableColorIconButton
          title="半透明 赤"
          imagePath="images/setting-popup/color/btn_color_red_02"
          active={fillColor === Color.RedTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.RedTransparent, dispatch);
          }} />
        <SelectableColorIconButton
          title="半透明 青"
          imagePath="images/setting-popup/color/btn_color_blue_02"
          active={fillColor === Color.BlueTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.BlueTransparent, dispatch);
          }} />
        <SelectableColorIconButton
          title="半透明 黄色"
          imagePath="images/setting-popup/color/btn_color_yellow_02"
          active={fillColor === Color.YellowTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.YellowTransparent, dispatch);
          }} />
        <SelectableColorIconButton
          title="半透明 緑"
          imagePath="images/setting-popup/color/btn_color_green_02"
          active={fillColor === Color.GreenTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.GreenTransparent, dispatch);
          }} />
        <SelectableColorIconButton
          title="半透明 黒"
          imagePath="images/setting-popup/color/btn_color_black_02"
          active={fillColor === Color.BlackTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.BlackTransparent, dispatch);
          }} />
        <SelectableColorIconButton
          title="半透明 白"
          imagePath="images/setting-popup/color/btn_color_white_02"
          active={fillColor === Color.WhiteTransparent}
          onClick={() => {
            ObjectDrawingUIAction.setColor(selected, Color.WhiteTransparent, dispatch);
          }} />
      </ToolIconRadioButtonSet>
    </SettingTabPanelListRow>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return {
    selected,
    fillColor: toolSettings[selected].color,
  };
};

export default connect(mapStateToProps)(ObjectFillColorTabPanelListRow);
